<div class="viewer-loading__header">
  <span class="viewer-loading__title">
    <span class="viewer-loading__badge">DEBUG</span>
    <span>Requests</span>
  </span>
  <span *ngIf="viewer.viewerGeometryLoadingActive && viewer.viewerLoadingProgressPercent !== null">
    {{ viewer.viewerLoadingProgressPercent }}%
  </span>
</div>
<div *ngIf="viewer.viewerGeometryLoadingActive" class="viewer-loading__section">
  <div class="viewer-loading__message">{{ viewer.viewerLoadingMessage }}</div>
  <progress
    *ngIf="viewer.viewerLoadingState.total !== null"
    class="viewer-loading__progress"
    [value]="viewer.viewerLoadingState.completed"
    [max]="viewer.viewerLoadingState.total"
  ></progress>
  <div *ngIf="viewer.viewerLoadingState.total === null" class="viewer-loading__track" aria-hidden="true">
    <span class="viewer-loading__indeterminate"></span>
  </div>
</div>
<div
  *ngIf="viewer.photogrammetryLoading.status.busy"
  class="viewer-loading__section viewer-loading__section--photogrammetry"
>
  <div class="viewer-loading__message viewer-loading__message--with-value">
    <span>{{ viewer.viewerPhotogrammetryLoadingMessage }}</span>
    <span *ngIf="viewer.viewerPhotogrammetryProgressPercent !== null" class="viewer-loading__value">
      {{ viewer.viewerPhotogrammetryProgressPercent }}%
    </span>
  </div>
  <progress
    *ngIf="viewer.viewerPhotogrammetryProgressPercent !== null"
    class="viewer-loading__progress"
    [value]="viewer.viewerPhotogrammetryProgressPercent"
    [max]="100"
  ></progress>
  <div *ngIf="viewer.viewerPhotogrammetryProgressPercent === null" class="viewer-loading__track" aria-hidden="true">
    <span class="viewer-loading__indeterminate"></span>
  </div>
</div>
